/**Тип сообщения */
export enum MessageTypeEnum {
  /**Информация */
  Info = "info",
  /**Предупреждение */
  Warning = "warning",
  /**Ошибка */
  Error = "error",
  /**СБП */
  Sbp = "sbp",
  /**Успешно */
  Success = "success"
}